import { IPartner } from 'clickNgo/entities/partner/models'

export function getCompanyAddress(partner: IPartner) {
  const address = [partner.addressLine1, partner.addressLine2, partner.addressLine3]
    .filter(Boolean)
    .join(', ')

  const city = [partner.zipCode, partner.city].filter(Boolean).join(' ')

  return [address, city, partner.country].filter(Boolean).join(', ')
}
